import { Component } from '@angular/core';

@Component({
    templateUrl: './dashboard.component.html',
})
export class DashboardComponent {
}



// WEBPACK FOOTER //
// /code/frontend/src/app/main/dashboard/dashboard.component.ts